import { createContext, useContext } from 'react';

import type { MediaProvider } from '@atlaskit/editor-common/provider-factory';
import type { AuthProvider } from '@atlaskit/media-core';

import type { HubContextType } from './types';

export const getAuthProvider =
	(asapIssuer: string, mediaToken: string, mediaUrl: string): AuthProvider =>
	async () => {
		return {
			asapIssuer,
			token: mediaToken,
			baseUrl: mediaUrl,
		};
	};

export const getMediaProvider = (
	mediaCollectionName: string,
	asapIssuer: string,
	mediaToken: string,
	mediaUrl: string,
): MediaProvider => ({
	uploadParams: {
		collection: mediaCollectionName,
	},
	viewMediaClientConfig: {
		authProvider: getAuthProvider(asapIssuer, mediaToken, mediaUrl),
		useSha256ForUploads: true,
	},
});

export const HubContext = createContext<HubContextType | null>(null);

export const useHubContext = () => {
	const context = useContext(HubContext);
	if (!context) {
		throw new Error('useHubContext must be used within a HubContextProvider');
	}
	return context;
};
